<div class="hello-books" *ngIf="siteSlug === 'hello-books'">
  <div class="logo"></div>
  <div class="header"></div>
</div>
<div *ngIf="site.banner" class="site-header" [style]="{ 'background-image': 'url(' + site.banner + ')' }"></div>
<div class="new-in-books-header mobile-optimization" 
  *ngIf="siteSlug === 'new-in-books'">
  <img loading="async" 
    src="https://storage.googleapis.com/wwm-static-content/new-in-books-header.png" 
    alt="https://storage.googleapis.com/wwm-static-content/new-in-books-header.png">
</div>
<section class="fs2-content" id="fs2" class="mobile-optimization" *ngIf="site">
	<div class="heading mobile-optimization">
    <h3 class="subtitle">Select Promo</h3>
		<div class="app-html-block" *ngIf="site.headerHTML" [innerHtml]="site.headerHTML"></div>
		<app-html-block *ngIf="!site.headerHTML" [blockArray]="site.headerContent"></app-html-block>
	</div>
	<hr/>
  <div class="loading-container">
    <app-spinner *ngIf="loading"></app-spinner>
  </div>
  <div *ngIf="!loading">
    <div class="column-row column-row-header">
      <div class="genre genre-header"><strong>Genre</strong></div>
      <div class="list-size list-size-header" *ngIf="site.toggleDisplayAudienceColumnOnPurchaseFlow"><strong>Audience</strong></div>
      <div class="price"><strong>Price</strong></div>
      <div 
        class="price gold-premium-header" 
        *ngIf="showGoldPlatinumDiscount(isMember, displayGoldPlatinumPriceColumn, displayFreeGuestPriceColumn)"
      >
        <strong>{{ role && role !== 'Free' ? 'Your member price' : 'Gold & Platinum Members Pay' }}</strong>
      </div>
      <div class="purchase-link">&nbsp;</div>
    </div>
    <div class="site-advert-group mobile-optimization" 
      *ngFor="let group of siteAdvertsSpecific | async; let i = index">
      <div class="title-bar">
        <div class="title" [class]="{'shorten-title': !site.toggleDisplayAudienceColumnOnPurchaseFlow}">{{group.title}}</div>
        <div class="learn-more" *ngIf="displayFreeGuestPriceColumn && (!role || role === 'Free') && i === 0 && mobileOptimization()">
          <a [href]="subscriptionsLink" target="_blank">Learn more</a>
        </div>
      </div>
      <div class="site-advert">
        <div class="site-advert-item" *ngFor="let advert of group.content; ">
          <div class="column-row">
            <div class="column-row-item genre">
              <a id="{{advert.seoSlug}}" class="genre-link" (click)="handleLink($event, advert, group)">
                {{advert.name}}
                <div class="detail" *ngIf="advert?.giveaway?.isGiveaway">
                  {{advert.giveaway.startDate | pubDate }} - {{advert.giveaway.endDate | pubDate }}
                </div>
                <span class="availableTo" *ngIf="!roleNames(advert.availableTo).includes('Free') && !roleNames(advert.availableTo).includes(role)">
                  (Gold and Platinum Members)
                </span>
                <span class="availableTo" *ngIf="!roleNames(advert.availableTo).includes('Free') && roleNames(advert.availableTo).includes(role)">
                  (Early access for you)
                </span>
              </a>
            </div>
            <div class="column-row-item list-size" *ngIf="site.toggleDisplayAudienceColumnOnPurchaseFlow">
              <b>{{ formatAudience(advert.expectedReach) }}</b>
            </div>
            <div class="column-row-item price p-relative">
              <span 
                *ngIf="showGoldPlatinumDiscount(isMember, displayGoldPlatinumPriceColumn, displayFreeGuestPriceColumn)" 
                [class]="{ 'discount-applied-line': displayGoldPlatinumPriceColumn && isMember }"
              >
                &nbsp;
              </span>
              <b>{{ mobileOptimization()? (advert.price | currency:'USD') : '$'+advert.price }}</b>
            </div>
            <div 
              class="column-row-item gold-premium-body price" 
              *ngIf="showGoldPlatinumDiscount(isMember, displayGoldPlatinumPriceColumn, displayFreeGuestPriceColumn)"
            >
              <span class="gold-premium-price"><b>${{priceForGoldPlatinumMembers(advert.price)}}</b></span>
            </div>
            <div class="column-row-item purchase-link">
              <div>
              <a class="border-btn" (click)="handleLink($event, advert, group)">{{ mobileOptimization()? 'Purchase' : 'Buy' }}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
	<div *ngIf="isFBAdCampaign" class="example-ads-link">
		<a (click)="onOpenModalRequested()">What do the ads look like?</a>
	</div>
</section>
<app-membership-modal 
  [userNotLogged]="false" 
  [modalId]="'modal-promo'"
  [authorLink]="authorLink"
  [hideButtonText]="!isMember"
  [learnMoreButton]="true"
  [buttonText]="'Upgrade'"
  [text]="text" [subText]="subText"
  (confirmChoice)="upgrade($event)"
></app-membership-modal>
